import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';
import { toDateOnlyString } from '../../../../../../shared/utils/date-utils';

@Component({
  selector: 'app-complete-warehouse-date',
  standalone: true,
  imports: [RmsModule, FormsModule],
  templateUrl: './complete-warehouse-date.component.html',
  styleUrl: './complete-warehouse-date.component.scss'
})
export class CompleteWarehouseDateComponent {
  InventoryItem: any;
  DateIn: string;
  errorMessage: string | null = null;

  constructor(@Inject(RMS_PULLDOWN_DATA) private data: any, public ref: RmsPulldownRef) {
    this.InventoryItem = data || {};
    this.DateIn = toDateOnlyString(this.InventoryItem?.DateIn);
  }

  save(): void {
    this.errorMessage = null;
    if (!this.DateIn) {
      this.errorMessage = 'Enter the date created in the warehouse.';
      return;
    }
    this.ref.close({ DateIn: this.DateIn, cancelled: false });
  }

  cancel(): void {
    this.ref.close({ cancelled: true });
  }
}
